import { render, staticRenderFns } from "./chapterPlay.vue?vue&type=template&id=6e85e61a&scoped=true&"
import script from "./chapterPlay.vue?vue&type=script&lang=js&"
export * from "./chapterPlay.vue?vue&type=script&lang=js&"
import style0 from "./chapterPlay.vue?vue&type=style&index=0&id=6e85e61a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e85e61a",
  null
  
)

export default component.exports